export default __webpack_public_path__ + "success.fc0218fb.svg";